<template>
    <div>
        <div :class="'totalizer-block'">
            <div>
                <div>
                    <div :class="'totalizer-block__inner' + (!noIconTotalizer?' inner-gap totalizer-block-display':'')">
                        <span v-if="!noIconTotalizer">
                            <i :class="iconClass"></i>
                        </span>
                        <span class="totalizer-block__inner-text">
                            {{ text }}
                        </span>
                    </div>
                    <div>
                        <span class="totalizer-block__inner-number" v-if="number">
                            <div>{{ number }}</div>
                            <div v-if="numberSecondColumn && numberSecondColumn !== ''">
                                {{ numberSecondColumn }}
                            </div>
                        </span>
                        <span class="totalizer-block__inner-number" v-else>
                            {{ "-" }}
                        </span>
                    </div>
                </div>
                <div v-if="secondRowData">
                    <span class="totalizer-block__inner-number" v-if="hasSecondRowData">
                        {{ secondRowData }}
                    </span>
                    <span class="totalizer-block__inner-number" v-else>
                        {{ "-" }}
                    </span>
                </div>
                <div class="detailed-info" v-if="detailedInformation.length !== 0">
                    <div
                        v-for="info in detailedInformation"
                        :key="info.codigo"
                        class="detailed-info-row"
                    >
                        <div class="detailed-info_right_column">
                            <div class="detailed-info-label">
                                {{ info.label }}
                            </div>
                        </div>
                        <div class="detailed-info_left_column">
                            <div class="detailed-info-value">{{ info.value }}</div>
                            <div class="dotted-divider"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="totalizer-block__detail-button"  v-if="seeDetailOption()">
                    <go-to-button
                        :route="routeName"
                        :text="translate('messages.details')"
                        icon="el-icon-right"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoToButton from '@/modules/warehouse/views/components/GoToButton.vue';

export default {
    name: 'TotalizerBlock',
    components: { GoToButton },
    props: {
        text: {
            type: String,
            default: () => ''
        },
        number: {
            type: String,
            default: () => ''
        },
        numberSecondColumn: {
            type: String,
            default: () => ''
        },
        iconClass: {
            type: String,
            default: () => ''
        },
        noIconTotalizer: {
            type: Boolean,
            default: () => false
        },
        secondRowData: {
            type: String,
            default: () => ''
        },
        routeName: {
            type: String,
            default: () => ''
        },
        detailedInformation: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {};
    },
    methods: {
        hasSecondRowData() {
            return this.secondRowData && this.secondRowData !== '';
        },
        seeDetailOption() {
            return this.routeName && this.routeName !== '';
        },
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        }
    }
};
</script>

<style lang="scss" scoped>
.totalizer-block-display{
    display: flex;
}
.inner-gap {
    margin: 0 0 8px 0;
}
.totalizer-block {
    min-width: 24%;
    width: auto;
    background: var(--white);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 89px;
    height: 100%;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    padding: 20px 20px 8px;
    .detailed-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin: 16px 0 24px 0;

        .detailed-info-row{
            display: flex;
            justify-content:space-between;
            .detailed-info_right_column {
                display: flex;
                justify-content:start;
                width: fit-content;
                .detailed-info-label {
                    width: fit-content;
                    white-space: nowrap;
                }
            }
            .detailed-info_left_column {
                display: flex;
                flex-direction: row-reverse;
                width: 100%;
                word-break: keep-all;
                .dotted-divider {
                    border-bottom: 2px dotted #bbb;
                    margin: 0 8px 0 8px;
                    min-width: 30px;
                    width:inherit;
                }
                .detailed-info-value{
                    width: min-content !important;
                    white-space: nowrap;
                }
            }
        }
    }
    .totalizer-block__inner {
        margin-right: 3px;
        display: flex;
        justify-content: left;
        align-items: center;

        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
        .lyra-icon {
            display: flex;
            padding-right: 0.5rem;
        }
        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 28px !important;
            background-color: var(--primary) !important;
            opacity: 1;
        }
    }
    .totalizer-block__inner-number {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        font-size: 22px;
        font-weight: 500;
    }
    span {
        padding: 3px;
        &.totalizer-block__inner-text {
            max-width: 250px;
            font-weight: 500;
        }
    }
    .totalizer-block__detail-button {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 100%;
        text-align: center;
        font-weight: 500;
        margin-top: 8px;
    }
    .totalizer-block__go-to {
        font-weight: 500 !important;
    }

    &:first-child {
        margin: 2px 0px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 0px 2px 2px;
    }
}
@media only screen and (max-width: 1334px) {
    .totalizer-block {
        min-width: 48% !important;
    }
}
</style>
